const SystemUserTagCodes = Object.freeze({
    LOGIN_SIMULATE365: "LOGIN_SIMULATE_365",
    LOGIN_DWSIM_PRO: "LOGIN_DWSIM_PRO",
    LOGIN_DWSIM: "LOGIN_DWSIM",
    LOGIN_DASHBOARD: "LOGIN_DASHBOARD",
    LOGIN_VM: "LOGIN_VM",
    CONSUMER: "CONSUMER",
    COMPANY: "COMPANY",
    CONSULTING: "CONSULTING",
    UNIVERSITY: "UNIVERSITY",
    TRIAL_USER: "TRIAL_USER",
    CUSTOMER: "CUSTOMER",
    TEST_USER: "TEST_USER",
    ACCEPTED_DASHBOARD_EULA: "ACCEPTED_DASHBOARD_EULA",
    ACCEPTED_DWSIM_PRO_EULA: "ACCEPTED_DWSIM_PRO_EULA",
    CONFIRMED_EMAIL: "CONFIRMED_EMAIL",
    SUBMITTED_BUSINESS_EMAIL: "SUBMITTED_BUSINESS_EMAIL",
    CONFIRMED_BUSINESS_EMAIL: "CONFIRMED_BUSINESS_EMAIL",
    WATCHED_TOUR: "WATCHED_TOUR",
    UPLOADED_SAVED_FILE_ON_DASHBOARD: "UPLOADED_SAVED_FILE_ON_DASHBOARD",
    SHARED_FILE_ON_DASHBOARD: "SHARED_FILE_ON_DASHBOARD",
    READY_TO_ORDER:"ReadyToOrder"
});

export default SystemUserTagCodes;